// Komal Verma Portfolio Data

export const actorInfo = {
  name: "Komal Verma",
  tagline: "Screen Actress | Storyteller",
  shortBio: "A versatile performer trained under NSD Gold Medalist Alok Chatterjee and FTII, ready to bring depth and authenticity to lead roles in films and web series.",
  bio: "I am an actor driven by the belief that every character holds a story worth telling with truth and courage. My training under the acclaimed Alok Chatterjee (NSD Gold Medalist) taught me the craft of emotional honesty and layered performance. To strengthen my screen presence, I trained through FTII's Screen Acting Program under Siddharth Shasta, refining my understanding of cinematic storytelling and camera technique. I have also undertaken the Navarasa Sadhana workshop under Guru G. Venu, deepening my grounding in classical emotive expression.\n\nGrowing up across different states in India has given me a unique cultural lens that gives me an ability to slip into diverse characters, understand regional nuances, and speak multiple languages authentically. This versatility, combined with my training in martial arts and performing arts, allows me to take on physically demanding and emotionally complex roles.\n\nI see myself as the kind of lead actress who holds the heartbeat of a story, someone who brings sincerity, strength, and grace to the screen. My journey has been shaped by determination (I'm a graduate of SRCC, Delhi) and a deep commitment to my craft. I'm selective about projects that challenge me and allow me to stay true to the art of storytelling.\n\nWhether it's a powerful dramatic role, an action-packed character, or a culturally rooted narrative, I'm ready to bring authenticity and depth to the screen.",
  height: "5'6\"",
  location: "Mumbai",
  native: "Rajasthan",
  email: "komal.swc@gmail.com",
  phone: "+91-9560311593",
  education: "Graduate, Shri Ram College of Commerce (SRCC), Delhi University",
  instagram: "https://instagram.com/komalunveiled?igshid=NGVhN2U2NjQ0Yg==",
  letterboxd: "https://letterboxd.com/actor/komal-verma-1/",
  imdb: "https://www.imdb.com/name/nm18566740/",
  
  showreelUrl: "https://youtu.be/7FKoEsQaego?si=x1jIbrasMFpi8ktp",
  
  photos: {
    hero: "https://customer-assets.emergentagent.com/job_actingfolio/artifacts/argqat2o__MG_3894.JPG",
    about: "https://customer-assets.emergentagent.com/job_versatile-actress/artifacts/7svsw8nw_IMG_5995.JPG"
  }
};

export const languageShowcase = [
  {
    language: "Hindi",
    region: "National Language",
    description: "Standard Hindi performance demonstrating versatility for mainstream cinema",
    photo: "https://customer-assets.emergentagent.com/job_versatile-actress/artifacts/nw7mjggl_IMG_0586.JPG",
    auditionUrl: "https://youtu.be/ajlKb-hNuwE",
    color: "#FF6B35",
    iconName: "Home"
  },
  {
    language: "English",
    region: "International Content",
    description: "Contemporary English performance for web series and international projects",
    photo: "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/knn5352p_DSCF0236.jpg",
    auditionUrl: "https://youtu.be/lv4JaL-3ctM",
    color: "#8B5CF6",
    iconName: "Globe"
  },
  {
    language: "Haryanvi",
    region: "Haryana",
    description: "Authentic portrayal of rural Haryanvi character with regional dialect and mannerisms",
    photo: "https://customer-assets.emergentagent.com/job_versatile-actress/artifacts/mp3u0u15_Haryanvi.jpg",
    auditionUrl: "https://youtu.be/frH-Ie9BCtY",
    color: "#DC2626",
    iconName: "Wheat"
  },
  {
    language: "Punjabi",
    region: "Punjab",
    description: "Energetic and expressive Punjabi character performance with cultural authenticity",
    photo: "https://customer-assets.emergentagent.com/job_versatile-actress/artifacts/0hfxg5t5_Punjabi_2.png",
    auditionUrl: "https://youtu.be/aKGJgIx7P9E",
    color: "#F59E0B",
    iconName: "Music"
  },
  {
    language: "Pahadi",
    region: "Uttarakhand/Himachal",
    description: "Authentic Pahadi dialect showcasing Himalayan cultural roots and regional authenticity",
    photo: "https://customer-assets.emergentagent.com/job_versatile-actress/artifacts/7df3kt23_Himachal.png",
    auditionUrl: "https://youtu.be/l_hUAYc_kH4",
    color: "#0EA5E9",
    iconName: "Mountain"
  }
];

export const training = [
  {
    institution: "Film and Television Institute of India (FTII)",
    course: "Online Screen Acting Foundation Course",
    mentor: "Siddharth Shasta (Professor and Head of the Screen Acting Department at FTII)",
    description: "Intensive training in cinematic performance, camera techniques, and emotional precision for screen acting",
    year: "2021"
  },
  {
    institution: "Advanced Acting Training",
    course: "Advanced Acting Course",
    mentor: "Alok Chatterjee (NSD Gold Medalist)",
    description: "Comprehensive training in the craft of emotional truth, character development, and layered performance techniques",
    year: "2022-2023"
  },
  {
    institution: "Natanakairali",
    course: "Navarasa Sadhana",
    mentor: "Guru G. Venu",
    description: "Immersive training in Navarasa Sadhana — the classical Indian discipline of mastering the nine emotions (rasas) for authentic and expressive performance",
    year: "August 2026"
  }
];

export const skills = {
  combatPhysical: [
    { name: "Judo", level: "State Level Player" },
    { name: "Wrestling", level: "State Level Player" },
    { name: "Kalaripayattu", level: "Intermediate Practitioner" },
    { name: "Swimming", level: "Trained" }
  ],
  performingArts: [
    { name: "Singing", level: "Dhrupad Classical (Beginner)" },
    { name: "Dancing", level: "Trained" }
  ],
  languages: {
    fluent: [
      "Hindi",
      "English",
      "Bagri (Rajasthani Dialect)"
    ],
    proficient: [
      "Haryanvi",
      "Punjabi",
      "Bundelkhandi"
    ]
  }
};

export const projects = [
  {
    title: "Postpartum",
    type: "Feature Film",
    role: "Lead Actress",
    year: "2025",
    description: "Released on Airtel Xtream, Hungama OTT and Tata Play Binge.\n\nIn the quiet hum of a middle-class home, Vaibhavi, a school teacher, navigates the tension between societal expectations and personal choice as buried emotions about motherhood and identity surface in a quiet moment of reconciliation.",
    videoUrl: "https://youtu.be/TN5fYebThbw",
    thumbnail: "https://img.youtube.com/vi/TN5fYebThbw/maxresdefault.jpg",
    linkText: "Watch Trailer"
  },
  {
    title: "Escape",
    type: "Short Film",
    role: "Lead Actress",
    year: "2025",
    description: "Released on Youtube.\n\nEscape is a gripping thriller that plunges into the dark underbelly of a situationship",
    videoUrl: "https://youtu.be/Lm8GOZLeEhs?si=wFQus581XzCUlglW&t=54",
    thumbnail: "https://img.youtube.com/vi/Lm8GOZLeEhs/maxresdefault.jpg"
  },
  {
    title: "Music Video (Vevo)",
    type: "Music Video",
    role: "Lead Actress",
    year: "2024",
    description: "Featuring as leading actress in professional music video produced by Vevo.\n\nThis emotional ballad captures the essence of love, heartbreak, and reflection",
    videoUrl: "https://youtu.be/pR9Kc8qqfM8?si=Fh04b2ssLtiPRGF8",
    thumbnail: "https://img.youtube.com/vi/pR9Kc8qqfM8/maxresdefault.jpg"
  },
  {
    title: "Anandmath",
    type: "Theatre Production",
    role: "Shanti (Lead Role)",
    director: "Alok Chatterjee",
    year: "2023",
    description: "Lead role in this acclaimed theatrical production directed by NSD Gold Medalist Alok Chatterjee"
  },
  {
    title: "Subhagi",
    type: "Theatre Production",
    role: "Subhagi (Lead Role)",
    director: "Alok Chatterjee",
    year: "2022",
    description: "Played the titular role in this powerful play inspired by the story of Subhadra Kumari Chauhan, portraying the journey and struggles of Subhagi"
  }
];

export const experience = {
  theatre: "4+ years of active theatre performance",
  screen: "Featured in films, web content, and music videos",
  specialization: "Lead roles in dramatic and action-oriented content"
};
